// ============================================
// Chat Module - Overlay Functions (ES6)
// ============================================

import { useHomeStore } from '../../stores/homeStore.js';
import { updateDetailActionButtons } from '../home/detail/actions.js';
import { ModalManager } from '../modal-manager.js';
import { cleanupTTS } from './tts/index.js';

// ============================================
// 채팅 오버레이 관리
// ============================================

export function isChatOverlayActive() {
  return document.getElementById('chatOverlay')?.classList.contains('active') ?? false;
}

export function openChatOverlay() {
  document.getElementById('chatOverlay').classList.add('active');
  // ModalManager에 등록 (뒤로가기로 닫을 수 있도록)
  // 이미 열려 있으면 다시 push하지 않음 (설정 모달 등이 위에 있을 때 z-index 꼬임 방지)
  if (!ModalManager.isOpen('chatOverlay')) {
    ModalManager.register('chatOverlay', closeChatOverlay, 'screen');
    ModalManager.push('chatOverlay');
  }
}

export function closeChatOverlay() {
  document.getElementById('chatOverlay').classList.remove('active');
  // TTS 정리 (재생 중지 및 큐 초기화)
  cleanupTTS();
  // Close memory panel if open
  const memoryPanel = document.querySelector('#chatOverlay .memory-panel');
  if (memoryPanel) {
    memoryPanel.classList.remove('active');
  }
  // ModalManager에서 제거 (memoryPanel도 함께 제거)
  // memoryPanel이 스택에 있으면 먼저 제거
  if (ModalManager.isOpen('memoryPanel')) {
    ModalManager.remove('memoryPanel', true);
    ModalManager.unregister('memoryPanel');
  }
  ModalManager.remove('chatOverlay', true);
  ModalManager.unregister('chatOverlay');

  // 상세 모달이 열려있으면 버튼 상태 갱신 (새로하기/이어하기)
  const selectedContent = useHomeStore.getState().selectedContentForDetail;
  if (ModalManager.isOpen('contentDetailModal') && selectedContent?.id) {
    updateDetailActionButtons(selectedContent.id);
  }
}

// ============================================
// 채팅 UI 상태 관리
// ============================================

export function showNoChatState() {
  // This function is now mostly unused with new UI
}

export function showChatContent() {
  document.getElementById('noChatState').style.display = 'none';
  document.getElementById('chatContent').style.display = 'flex';
}

// ============================================
// 모바일 메뉴
// ============================================

export function toggleSidebar() {
  const sidebar = document.querySelector('.sidebar');
  const overlay = document.getElementById('mobileOverlay');
  if (sidebar) sidebar.classList.toggle('open');
  if (overlay) overlay.classList.toggle('show');
}

export function closeMobileMenus() {
  const sidebar = document.querySelector('.sidebar');
  if (sidebar) sidebar.classList.remove('open');
  const memoryPanel = document.getElementById('memoryPanel');
  if (memoryPanel) memoryPanel.classList.remove('active');
  const mobileOverlay = document.getElementById('mobileOverlay');
  if (mobileOverlay) mobileOverlay.classList.remove('show');
}

export function showTab(tabName) {
  // 더 이상 사용하지 않음 - 로그인 화면만 표시
}

// ============================================
// window 노출 제거됨 (2026-01-06)
// 모든 호출이 ES6 import로 처리됨
// ============================================
